<div class="container-fluid chat-app pt10">
  <div class="row">
    <!-- Left Sidebar - Chat Users -->
    <div class="col-12 col-lg-3 users-panel" *ngIf="!chatData">
      <div class="users-tabs d-flex gap-2 px-2 py-2">
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-primary]="activeUsersTab === 'all'"
          [class.btn-outline-primary]="activeUsersTab !== 'all'"
          (click)="setUsersTab('all')"
        >
          All
        </button>
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-primary]="activeUsersTab === 'unread'"
          [class.btn-outline-primary]="activeUsersTab !== 'unread'"
          (click)="setUsersTab('unread')"
        >
          Unread
        </button>
      </div>
      <div class="chat-users">
        <ul class="user-list">
          <li
            *ngFor="let user of filteredUsers"
            
            (click)="selectUser(user)"
            [class.active]="selectedUser?.hcp_user_id == user.hcp_user_id"
          >
            <div class="user-item" (click)="scrolltoptobottom()">
              <div class="d-flex align-items-center gap-2">
               <div class="user-avatar">
  <ng-container *ngIf="user?.image; else initialsAvatar">
  <img
  [src]="drImageBaseUrl + user.image"
  class="user-avatar-img"
  [alt]="user.full_name"
  (error)="onImageError(user)"
/>
  </ng-container>

  <ng-template #initialsAvatar>
    <div class="avatar-fallback">
      {{ getInitials(user.full_name) }}
    </div>
  </ng-template>
</div>

                <div class="user-info">
                  <p class="user-name mb-1">{{ user.full_name }}</p>
                  <p class="user-last text-truncate mb-2">
                    {{ user.last_message || user.lastMessage || "Start conversation with " }}
                  </p>
                 <div class="user-meta d-flex align-items-center gap-1">
  <!-- Show SVG only if time exists -->
  <ng-container *ngIf="getUserLastTime(user)">
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
      <g clip-path="url(#clip0_559_2872)">
        <path d="M5.5 0C2.46721 0 0 2.46721 0 5.5C0 8.53279 2.46721 11 5.5 11C8.53279 11 11 8.53279 11 5.5C11 2.46721 8.53279 0 5.5 0ZM7.33333 5.95833H5.5C5.247 5.95833 5.04167 5.75346 5.04167 5.5V2.75C5.04167 2.49654 5.247 2.29167 5.5 2.29167C5.753 2.29167 5.95833 2.49654 5.95833 2.75V5.04167H7.33333C7.58679 5.04167 7.79167 5.24654 7.79167 5.5C7.79167 5.75346 7.58679 5.95833 7.33333 5.95833Z" fill="#092C44" fill-opacity="0.7"/>
      </g>
      <defs>
        <clipPath id="clip0_559_2872">
          <rect width="11" height="11" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </ng-container>

  <small class="user-time text-muted">
    {{
      getUserLastTime(user)
        ? (getUserLastTime(user) | date : "shortTime")
        : ""
    }}
  </small>
</div>

                </div>
              </div>
              <div
                class="unread-wrapper"
                *ngIf="
                  (user.unreadCount ??
                    user.unread_count ??
                    user.UnreadCount ??
                    0) >
                  0
                "
              >
                <span class="unread-badge">
                  {{
                    user.unreadCount ?? user.unread_count ?? user.UnreadCount
                  }}
                </span>
              </div>
            </div>
          </li>
           <li *ngIf="!filteredUsers || filteredUsers.length === 0" class="no-data text-center py-3">
        <div class="empty-state empty-statechat">
      <!-- your SVG here -->
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="30" viewBox="0 0 29 30" fill="none">
  <path d="M14.6211 0.97876C4.79358 0.97876 0.600006 5.17233 0.600006 14.9998C0.600006 24.8273 4.79358 29.0209 14.6211 29.0209C19.3398 29.0209 26.5351 28.4052 26.8398 28.3785C27.4592 28.3249 27.95 27.8329 28.001 27.2134C28.0277 26.896 28.6421 19.3884 28.6421 14.9998C28.6421 5.17233 24.4485 0.97876 14.6211 0.97876ZM8.88518 16.9118C7.82977 16.9118 6.97321 16.0552 6.97321 14.9998C6.97321 13.9444 7.82977 13.0879 8.88518 13.0879C9.94058 13.0879 10.7971 13.9444 10.7971 14.9998C10.7971 16.0552 9.94058 16.9118 8.88518 16.9118ZM14.6211 16.9118C13.5657 16.9118 12.7091 16.0552 12.7091 14.9998C12.7091 13.9444 13.5657 13.0879 14.6211 13.0879C15.6765 13.0879 16.533 13.9444 16.533 14.9998C16.533 16.0552 15.6765 16.9118 14.6211 16.9118ZM20.3569 16.9118C19.3015 16.9118 18.445 16.0552 18.445 14.9998C18.445 13.9444 19.3015 13.0879 20.3569 13.0879C21.4123 13.0879 22.2689 13.9444 22.2689 14.9998C22.2689 16.0552 21.4123 16.9118 20.3569 16.9118Z" fill="#20A090"/>
</svg>
      <p class="text-muted textmuteadchat1">No unread chats found 
</p>
      <p class="tabcontentp2 tabcontentp2chat" (click)="setUsersTab('all')">
         View all chats
      </p>
    </div>
    </li>
        </ul>
      </div>
    </div>

    <!-- Right Chat Window -->
    <div
      class="chat-panel col-12"
      [ngClass]="{
        'col-lg-5': rightPanelOpen,
        'col-lg-9': !rightPanelOpen,
        'col-lg-12':this.selectedUser?.data?.tbl_hcp?.tbl_user?.first_name
      }"
    >
      <div
        class="chat-header d-flex align-items-center justify-content-between px-3 py-2" [ngClass]="{'chat-header_top': !selectedUser?.full_name&&this.selectedUser?.data?.tbl_hcp?.tbl_user?.first_name}"
       *ngIf="selectedUser?.full_name||this.selectedUser?.data?.tbl_hcp?.tbl_user?.first_name">
        <!-- Left: Profile -->
        <div class="d-flex align-items-center">
    <div class="user-avatar hesder-avater">
  <ng-container *ngIf="selectedUser?.image; else initialsAvatar">
  <img
  [src]="drImageBaseUrl + selectedUser.image"
  class="user-avatar-img"
  [alt]="selectedUser.full_name"
  (error)="onImageError(selectedUser)"
/>
  </ng-container>

  <ng-template #initialsAvatar>
    <div class="avatar-fallback" *ngIf="selectedUser?.full_name">
      {{ getInitials(selectedUser.full_name) }}
    </div>
    <div class="avatar-fallback" *ngIf="!selectedUser?.full_name">
      {{ getInitials(this.selectedUser?.data?.tbl_hcp?.tbl_user?.first_name) }}
    </div>
  </ng-template>
</div>
          <div style="margin-top: 4px;">
            <h6 class="mb-0 fw-bold d-flex align-items-center gap-2">
              @if(selectedUser?.full_name){
                {{ selectedUser?.full_name || "Select a user" }}
              }
              @else{
                {{ this.selectedUser?.data?.tbl_hcp?.tbl_user?.first_name || "Select a user" }}
              }
              <!-- <span -->
              <!-- *ngIf="userStatus?.state" -->
              <!-- class="status-dot" -->
              <!-- [ngClass]="{ -->
              <!-- online: userStatus?.state === 'online', -->
              <!-- offline: userStatus?.state !== 'online' -->
              <!-- }" -->
              <!-- ></span> -->
              <!-- <span *ngIf="userStatus?.online">🟢 Online</span> -->
              <!-- <span *ngIf="!userStatus?.online"> -->
              <!-- Last seen: {{ userStatus?.lastSeen | date:'short' }} -->
              <!-- </span> -->
            </h6>
            <div *ngIf="!this.selectedUser?.data?.tbl_hcp?.tbl_user?.first_name">
                 <span *ngIf="userStatus?.online" class="on-off-line-text">
              Online</span
            >
            <span *ngIf="!userStatus?.online" class="on-off-line-text"
              >Offline</span
            >
            </div>
         
            <!-- <span *ngIf="!userStatus?.online"> -->
            <!-- Last seen: -->
            <!-- {{ -->
            <!-- (userStatus?.lastSeen?.toDate -->
            <!-- ? userStatus.lastSeen.toDate() -->
            <!-- : userStatus?.lastSeen -->
            <!-- ) | date : "short" -->
            <!-- }} -->
            <!-- </span> -->
            <!-- <span *ngIf="!userStatus?.online"> -->
            <!-- Last seen: {{ userStatus?.lastSeen | date:'short' }} -->
            <!-- </span> -->
            <!-- <small class="text-success" *ngIf="!userStatus?.online"> -->
            <!-- Active now -->
            <!-- </small> -->
            <!-- <small class="text-muted" *ngIf="!userStatus?.online"> -->
            <!-- Last seen {{ userStatus?.lastSeen | date: 'short' }} -->
            <!-- </small> -->
          </div>
        </div>

        <!-- Right: Options -->
        <div class="d-flex align-items-center">
          <!-- Shared Files Dropdown -->
          <div  *ngIf="!rightPanelOpen||!selectedUser?.data?.tbl_hcp?.tbl_user?.first_name" class="shared-files-wrapper position-relative" (click)="$event.stopPropagation()">
            <span class=" shared-files" (click)="openSidepanel()"  *ngIf="!selectedUser?.data?.tbl_hcp?.tbl_user?.first_name">
              Shared Files
            </span>
          </div>

          <div *ngIf="!selectedUser?.data?.tbl_hcp?.tbl_user?.first_name"
            class="header-menu-wrapper position-relative"
            (click)="$event.stopPropagation()"
          >
            <i
              class=" header-menu-icon"
              aria-label="More"
              (click)="toggleHeaderMenu($event)"
            ><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M9.99995 4.16664C11.1505 4.16664 12.0833 3.23391 12.0833 2.08332C12.0833 0.932734 11.1505 0 9.99995 0C8.84936 0 7.91663 0.932734 7.91663 2.08332C7.91663 3.23391 8.84936 4.16664 9.99995 4.16664Z" fill="black"/>
<path d="M9.99995 12.0833C11.1505 12.0833 12.0833 11.1505 12.0833 9.99995C12.0833 8.84936 11.1505 7.91663 9.99995 7.91663C8.84936 7.91663 7.91663 8.84936 7.91663 9.99995C7.91663 11.1505 8.84936 12.0833 9.99995 12.0833Z" fill="black"/>
<path d="M9.99995 20C11.1505 20 12.0833 19.0673 12.0833 17.9167C12.0833 16.7661 11.1505 15.8334 9.99995 15.8334C8.84936 15.8334 7.91663 16.7661 7.91663 17.9167C7.91663 19.0673 8.84936 20 9.99995 20Z" fill="black"/>
</svg></i>
            <ul class="header-dropdown" *ngIf="headerMenuOpen">
              <li (click)="clearAllChat()">
                <span class="hd-icon">
                  <fa-icon [icon]="faComments"></fa-icon>
                </span>
                <span class="hd-label">Clear all Chat</span>
              </li>
            </ul>
          </div>
          <!-- Three dots dropdown -->
        </div>
      </div>

      <!-- <div class="chat-header"> -->
      <!-- <h4>{{ selectedUser?.full_name || 'Select a user' }}</h4> -->
      <!-- </div> -->
    <div class="chat-container" #chatContainer>
  <!-- Check if messages exist -->
  <div *ngIf="groupedMessages && groupedMessages.length > 0; else noMessages">
    <div *ngFor="let msg of groupedMessages; trackBy: trackByMsgId">
      <!-- Date Separator -->
      <div *ngIf="msg.isDateSeparator" class="date-separator">
        <span>{{ msg.label }}</span>
      </div>

      <!-- Message Row -->
      <div
        *ngIf="!msg.isDateSeparator"
        class="message-row"
        [ngClass]="{
          sent: msg.senderId == patientUserId,
          received: msg.senderId != patientUserId
        }"
      >
     <div
  class="message-bubble"
  [ngClass]="{ 'image-bubble': msg.imageURL && isImageFile(msg.imageURL),
               'video-bubble': msg.imageURL && isVideoFile(msg.imageURL) }">


          <!-- Three Dot Menu -->
          <div class="menu-wrapper" (click)="$event.stopPropagation()">
            <i
              class="fa fa-ellipsis-v"
              aria-label="More"
              (click)="
                $event.stopPropagation(); msg.showMenu = !msg.showMenu
              "
            ></i>

            <ul
              *ngIf="msg.showMenu"
              class="menu-dropdown"
              (click)="$event.stopPropagation()"
            >
              <li
                *ngIf="!msg.imageURL && msg.senderId == patientUserId"
                (click)="
                  $event.stopPropagation();
                  msg.isEditing = true;
                  msg.tempMessage = msg.message;
                  msg.showMenu = false
                "
              >
                <i class="fa fa-pencil"></i> Edit
              </li>
              <li
                *ngIf="msg.showMenu && msg.senderId == patientUserId"
                (click)="
                  deleteMessage(msg);
                  msg.showMenu = false;
                  $event.stopPropagation()
                "
              >
                <i class="fa fa-trash"></i> Delete
              </li>
              <li
                *ngIf="!msg.imageURL"
                (click)="
                  $event.stopPropagation();
                  copyMessage(msg.message);
                  msg.showMenu = false
                "
              >
                <i class="fa fa-copy"></i> Copy
              </li>
              <li
                (click)="
                  $event.stopPropagation();
                  replyToMessage(msg);
                  msg.showMenu = false
                "
              >
                <i class="fa fa-reply"></i> Reply
              </li>
            </ul>
          </div>

          <!-- Reply Preview -->
          <div
            *ngIf="msg.replySenderName && msg.replyToMessageText"
            class="reply-preview"
          >
            <strong>{{ msg.replySenderName }}</strong>
            <p class="reply-text">{{ msg.replyToMessageText }}</p>
          </div>

          <!-- View Mode -->
          <ng-container *ngIf="!msg.isEditing">
            <p *ngIf="msg.message" class="message-text">
              {{ msg.message }}
            </p>

            <!-- Image -->
            <img
              *ngIf="msg.imageURL && isImageFile(msg.imageURL)"
              [src]="msg.imageURL"
              alt="Image"
              class="message-image"
              (click)="openImagePreview(msg)"
            />

            <!-- Video -->
            <video
              *ngIf="msg.imageURL && isVideoFile(msg.imageURL)"
              [src]="msg.imageURL"
              controls
              class="message-video"
               (click)="$event.stopPropagation()"
            ></video>

            <!-- File -->
            <a
              *ngIf="msg.imageURL && !isImageFile(msg.imageURL)"
              [href]="msg.imageURL"
              [attr.download]="msg.original_filename || 'file'"
              target="_blank"
              class="file-link"
              (click)="$event.stopPropagation()"
            >
              📄 {{ msg.original_filename || "Download File" }}
            </a>

            <!-- Timestamp -->
            <div class="message-meta">
              <span class="message-time">
                {{ getMessageDate(msg) | date : "shortTime" }}
              </span>
            </div>
          </ng-container>

          <!-- Edit Mode -->
          <ng-container *ngIf="msg.isEditing">
            <div class="edit-box" (click)="$event.stopPropagation()">
              <textarea
                [(ngModel)]="msg.tempMessage"
                placeholder="Edit your message"
                class="edit-textarea1"
                rows="3"
              ></textarea>

              <div class="edit-actions">
                <button (click)="saveEdit(msg)"  class="editbtn">Save</button>
                <button (click)="msg.isEditing = false" class="editbtn">
                  Cancel
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
<ng-template #noMessages>
  <div class="no-data text-center d-flex align-items-center justify-content-center" style="height: 100%;">
    <div>
      <!-- Show image only when no user is selected -->
      <ng-container *ngIf="!selectedUser; else withUser">
        <img 
          src="img/chating/laptopicon.svg" 
          alt="Start conversation" 
          class="start-chat-img mb-3"
        />
        <p class=" textmuteadchat color_4">Select a wellness advisor from the left to <br> start a conversation</p>
      </ng-container>

      <!-- When user tab clicked -->
      <ng-template #withUser>
        <p class="text-muted textmuteadchat1">
          Start conversation with {{ selectedUser?.full_name }}
        </p>
      </ng-template>
    </div>
  </div>
</ng-template>
   <!-- <button
  *ngIf="!atTop"
  class="scroll-to-top"
  (click)="scrollToTop1()"
>
  ⬆
</button> -->

<!-- Scroll to Bottom Button -->

  <button
  *ngIf="!autoScroll"
  class="scroll-to-bottom"
  (click)="scrollToBottom1()"
>
    <img src="img/chating/downarrow.svg" alt="Scroll Down" />

</button>
</div>
<!-- <div #bottom>

</div> -->


      <!-- Reply Bar (shows above input if replying) -->
      <div *ngIf="replyingTo" class="reply-bar">
        <span
          >Replying to <strong>{{ replyingTo.senderName }}</strong
          >:</span
        >
        <p>
          {{
            replyingTo.message ||
              (replyingTo.imageURL
                ? "📷 Image"
                : replyingTo.original_filename || "File")
          }}
        </p>
        <button class="close-reply" (click)="cancelReply()">×</button>
      </div>

      <!-- <div class="chat-input"  *ngIf="selectedUser?.full_name||selectedUser?.tbl_hcp?.tbl_user?.first_name"> -->
        <!-- {{this.selectedUser?.data?.tbl_hcp?.tbl_user?.first_name}} -->
         <div class="chat-input" *ngIf="selectedUser?.full_name||this.selectedUser?.data?.tbl_hcp?.tbl_user?.first_name" >
        <!-- Attachment (WhatsApp-like) -->
        <div
          class="attach-wrapper position-relative"
          (click)="$event.stopPropagation()"
        >
          <button
            type="button"
            class="attach-btn"
            (click)="toggleAttachMenu($event)"
            aria-label="Attach"
            [class.open]="attachMenuOpen"
          >
            <span class="plus-icon"></span>
          </button>
          <!-- <button -->
          <!-- type="button" -->
          <!-- class="attach-btn" -->
          <!-- (click)="toggleAttachMenu($event)" -->
          <!-- aria-label="Attach" -->
          <!-- > -->
          <!-- 📎 -->
          <!-- </button> -->
          <div class="attach-menu" *ngIf="attachMenuOpen">
            <h4 class="menu-header">Share Content</h4>
            <ul>
            

          

              <li
                (click)="mediaInput.click(); attachMenuOpen = false"
                class="attach-item"
              >
                <div class="icon-wrapper media">
                  <!-- <i class="fa fa-image icon"></i> -->
                    <img src="img/chating/media.png" alt="img" class="chaitingimg">
                </div>
                <div class="text-wrapper">
                  <span class="title">Image</span>
                  <span class="subtitle">Share photos</span>
                </div>
              </li>

              <li
                (click)="docInput.click(); attachMenuOpen = false"
                class="attach-item"
              >
                <div class="icon-wrapper docs">
                <img src="img/chating/doc.png" alt="img" class="chaitingimg">
                </div>
                <div class="text-wrapper">
                  <span class="title">Documents</span>
                  <span class="subtitle">Share your files</span>
                </div>
              </li>
                  <li
                (click)="videoInput.click(); attachMenuOpen = false"
                class="attach-item"
              >
                <div class="icon-wrapper video">
                     <img src="img/chating/video.png" alt="img" class="chaitingimg">
                </div>
                <div class="text-wrapper">
                  <span class="title"> Video</span>
                </div>
              </li>
                <li
                (click)="openCamera(); attachMenuOpen = false"
                class="attach-item"
              >
                <div class="icon-wrapper camera">
                <img src="img/chating/camera.png" alt="img" class="chaitingimg">
                </div>
                <div class="text-wrapper">
                  <span class="title">Capture Image</span>
                </div>
              </li>
            </ul>
          </div>

          <!-- Hidden inputs -->
          <input
            #imageInput
            type="file"
            accept="image/*"
            capture="environment"
            hidden
            (change)="onFileSelected($event)"
          />
          <input
            #videoInput
            type="file"
            accept="video/*"
            capture
            hidden
            (change)="onFileSelected($event)"
          />
          <input
            #mediaInput
            type="file"
            accept="image/*,video/*"
            hidden
            (change)="onFileSelected($event)"
          />
          <input
            #docInput
            type="file"
            accept="application/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
            hidden
            (change)="onFileSelected($event)"
          />
        </div>

        <!-- Preview Section -->
        <div *ngIf="selectedFile" class="file-preview">
          <!-- Image Preview -->
          <img
            *ngIf="selectedFile.type.startsWith('image')"
            [src]="filePreviewUrl"
            alt="Preview"
          />

          <!-- Non-image Preview -->
          <div *ngIf="!selectedFile.type.startsWith('image')" class="file-info">
            📄 {{ selectedFile.name }}
          </div>

          <!-- Remove File Button -->
          <button class="remove-btn" (click)="removeSelectedFile()">✖</button>
        </div>

        <!-- Caption / Message Input -->
        <!-- <input [(ngModel)]="newMessage"  -->
        <!-- [placeholder]="selectedFile ? 'Add a caption...' : 'Type a message...'"  -->
        <!-- (keyup.enter)="send()" /> -->
        <textarea
          #msgInput
          class="chat-textarea form-control"
          [(ngModel)]="newMessage"
          [placeholder]="
            selectedFile ? 'Add a caption...' : 'Write your message...'
          "
          rows="1"
          (input)="autoResize(msgInput)"
          (keydown.enter)="onEnter($event)"
          [disabled]="isSending"
          autocomplete="off"
          autocorrect="off"
          spellcheck="true"
        >
        </textarea>

        <!-- Send Button -->
        <!-- <button
          (click)="send()"
          [disabled]="isSending || (!newMessage.trim() && !selectedFile)"
        >
          ➤
        </button> -->
        <button
  (click)="send()"
  [disabled]="isSending || (!newMessage.trim() && !selectedFile)"
>
  <img
    [src]="
      isSending || (!newMessage.trim() && !selectedFile)
        ? 'img/chating/senddesable.png'
        : 'img/chating/sendenable.png'
    "
    alt="Send"
    width="40"
    height="40"
  />
</button>

      </div>
    </div>

    <div
      *ngIf="rightPanelOpen"
      [ngClass]="{ 'col-12 col-lg-4': rightPanelOpen }"
      [@slidePanel]
      style="padding-left: 2px;padding-right: 2px;"
    >
      <div
        class="chat-info bg-white p-3  d-flex flex-column overflow-hidden"
        style="height: 92vh"
      >
        <!-- Panel Header -->
        <div class="shared-header d-flex align-items-center gap-2 ">
          <button
            type="button"
            class="icon-btn"
            aria-label="Back"
            (click)="closeRightPanel()"
          >
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M10 8L6 12M6 12L10 16M6 12L18 12" stroke="#000E08" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
          </button>
          <h6 class="mb-0" >Shared Files</h6>
        </div>

        <!-- Custom Tabs (pills) -->
        <div class="custom-tabs">
          <button
            type="button"
            class="tab-btn "
            [class.active]="activeInfoTab === 'media'"
            (click)="setInfoTab('media')"
          >
            Media
          </button>
          <button
            type="button"
            class="tab-btn"
            [class.active]="activeInfoTab === 'docs'"
            (click)="setInfoTab('docs')"
          >
            Docs
          </button>
          <button
            type="button"
            class="tab-btn"
            [class.active]="activeInfoTab === 'links'"
            (click)="setInfoTab('links')"
          >
            Links
          </button>
        </div>

      <p class="section-title mt-3 mb-2" 
   *ngIf="
     (activeInfoTab === 'media' && media?.length) ||
     (activeInfoTab === 'docs' && docs?.length) ||
     (activeInfoTab === 'links' && extractedLinks?.length)
   ">
  Recent
</p>
        <!-- Tab Content (no internal scrollbars) -->
         
        <div class="tab-content mt-3 flex-grow-1 overflow">
          <!-- Media Tab -->
          <div *ngIf="activeInfoTab === 'media'">
            <ng-container *ngIf="media?.length; else noMedia">
              <div class="row g-3 media-grid">
                <ng-container *ngFor="let msg of media">
                  <!-- <div -->
                  <!-- class="col-4" -->
                  <!-- *ngIf="msg.imageURL && isImageFile(msg.imageURL)" -->
                  <!-- > -->
                  <!-- <img -->
                  <!-- [src]="msg.imageURL" -->
                  <!-- alt="Media" -->
                  <!-- class="media-thumb" -->
                  <!-- (click)="openImagePreview(msg.imageURL)" -->
                  <!-- /> -->
                  <!-- </div> -->
                  <!-- If it's an image -->
                  <div
                    class="col-4"
                    *ngIf="msg.file_type?.startsWith('image/')"
                  >
                    <img
                      [src]="msg.imageURL"
                      alt="Image"
                      class="media-thumb"
                      (click)="openImagePreview(msg)"
                    />
                  </div>

                  <!-- If it's a video -->
                  <div
                    class="col-4"
                    *ngIf="msg.file_type?.startsWith('video/')"
                  >
                    <video
                      class="media-thumb"
                      controls
                      (click)="openVideoPreview(msg.imageURL)"
                    >
                      <source [src]="msg.imageURL" [type]="msg.file_type" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #noMedia>
 <div class="empty-state">
  <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
    <g clip-path="url(#clip0_550_1495)">
      <path d="M0 38.25V10.625C0 5.93725 3.81225 2.125 8.5 2.125H12.75C13.736 2.125 14.722 2.35662 15.6017 2.7965L22.3061 6.14975C22.5994 6.29638 22.9287 6.37288 23.256 6.37288H34C39.8586 6.37288 44.625 11.1392 44.625 16.9979H21.301C15.6953 16.9979 10.6696 20.7506 9.07375 26.1418L3.39362 45.9871C1.3175 44.047 0 41.3079 0 38.25ZM49.9226 23.4111C48.9047 22.0448 47.3535 21.2606 45.6556 21.233C45.6237 21.233 45.5983 21.25 45.5664 21.25H21.301C17.5653 21.25 14.2141 23.7511 13.1537 27.3318L7.1655 48.2481C8.25562 48.6264 9.40737 48.875 10.625 48.875H37.3107C42.041 48.875 46.1295 45.832 47.515 41.2101L50.7705 28.2136C51.2677 26.5519 50.9575 24.803 49.9226 23.4111Z" fill="#20A090"/>
    </g>
    <defs>
      <clipPath id="clip0_550_1495">
        <rect width="51" height="51" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  <p class="text-muted">No links shared yet.</p>
  <p class="tabcontentp2">Start sharing files or links, and<br>they'll appear here</p>
</div>          
  </ng-template>
          </div>

          <!-- Docs Tab -->
          <div *ngIf="activeInfoTab === 'docs'">
            <ng-container *ngIf="docs?.length; else noDocs">
              <ul class="doc-list">
                <ng-container *ngFor="let msg of docs">
                  <li
                    class="doc-item"
                    *ngIf="msg.imageURL && !isImageFile(msg.imageURL)"
                  >
                    <a
                      class="doc-link"
                      [href]="msg.imageURL"
                      target="_blank"
                      [attr.download]="msg.original_filename || 'file'"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="doc-left">
                        <div class="doc-icon">
                          <img src="img/Vector.svg">
                        </div>
                        <div class="doc-info">
                          <div class="doc-title text-truncate">
                            {{ msg.original_filename || "Document" }}
                          </div>
                          <div class="doc-subtitle">
                            Shared on 
                            {{ getMessageDate(msg) | date : "d MMMM y" }}
                          </div>
                        </div>
                      </div>
                    </a>
                    <div
                      class="doc-menu"
                      (click)="downloadDoc(msg); $event.stopPropagation()"
                      title="Download"
                    >
                      <!-- <i class="fa fa-ellipsis-v" aria-label="Download"></i> -->
                    </div>
                  </li>
                </ng-container>
              </ul>
            </ng-container>
            <ng-template #noDocs>
              <div class="empty-state">
  <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
    <g clip-path="url(#clip0_550_1495)">
      <path d="M0 38.25V10.625C0 5.93725 3.81225 2.125 8.5 2.125H12.75C13.736 2.125 14.722 2.35662 15.6017 2.7965L22.3061 6.14975C22.5994 6.29638 22.9287 6.37288 23.256 6.37288H34C39.8586 6.37288 44.625 11.1392 44.625 16.9979H21.301C15.6953 16.9979 10.6696 20.7506 9.07375 26.1418L3.39362 45.9871C1.3175 44.047 0 41.3079 0 38.25ZM49.9226 23.4111C48.9047 22.0448 47.3535 21.2606 45.6556 21.233C45.6237 21.233 45.5983 21.25 45.5664 21.25H21.301C17.5653 21.25 14.2141 23.7511 13.1537 27.3318L7.1655 48.2481C8.25562 48.6264 9.40737 48.875 10.625 48.875H37.3107C42.041 48.875 46.1295 45.832 47.515 41.2101L50.7705 28.2136C51.2677 26.5519 50.9575 24.803 49.9226 23.4111Z" fill="#20A090"/>
    </g>
    <defs>
      <clipPath id="clip0_550_1495">
        <rect width="51" height="51" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  <p class="text-muted">No links shared yet.</p>
  <p class="tabcontentp2">Start sharing files or links, and<br>they'll appear here</p>
</div>
            </ng-template>
          </div>

          <!-- Links Tab -->
         <div *ngIf="activeInfoTab === 'links'">
  <ng-container *ngIf="extractedLinks?.length; else noLinks">
    <ul class="links-list">
      <li *ngFor="let l of extractedLinks" class="links-item">
        <div class="nav-icon "><img src="img/Vector2.svg"></div>
      
        <a [href]="l.url" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
          {{ l.text }}
           <div class="doc-subtitle">
  Shared on
  {{
    l.timestamp
      ? ((l.timestamp?.toDate ? l.timestamp.toDate() : l.timestamp) | date : "d MMM y, h:mm a")
      : "Not available"
  }}
</div>
        </a>
        <div  class="doc-menu">
             <!-- <i class="fa fa-ellipsis-v" aria-label="Download"></i> -->
        </div>
    
      </li>
  
    </ul>
    
  </ng-container>

  <ng-template #noLinks>
    <div class="empty-state">
      <!-- your SVG here -->
        <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
    <g clip-path="url(#clip0_550_1495)">
      <path d="M0 38.25V10.625C0 5.93725 3.81225 2.125 8.5 2.125H12.75C13.736 2.125 14.722 2.35662 15.6017 2.7965L22.3061 6.14975C22.5994 6.29638 22.9287 6.37288 23.256 6.37288H34C39.8586 6.37288 44.625 11.1392 44.625 16.9979H21.301C15.6953 16.9979 10.6696 20.7506 9.07375 26.1418L3.39362 45.9871C1.3175 44.047 0 41.3079 0 38.25ZM49.9226 23.4111C48.9047 22.0448 47.3535 21.2606 45.6556 21.233C45.6237 21.233 45.5983 21.25 45.5664 21.25H21.301C17.5653 21.25 14.2141 23.7511 13.1537 27.3318L7.1655 48.2481C8.25562 48.6264 9.40737 48.875 10.625 48.875H37.3107C42.041 48.875 46.1295 45.832 47.515 41.2101L50.7705 28.2136C51.2677 26.5519 50.9575 24.803 49.9226 23.4111Z" fill="#20A090"/>
    </g>
    <defs>
      <clipPath id="clip0_550_1495">
        <rect width="51" height="51" fill="white"/>
      </clipPath>
    </defs>
  </svg>
      <p class="text-muted">No links shared yet.</p>
      <p class="tabcontentp2">
        Start sharing files or links, and<br />they'll appear here
      </p>
    </div>
  </ng-template>
</div>



        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for Image Preview -->

<div
  class="modal"
  id="filePreviewModal"
  style="background: rgba(0, 0, 0, 0.85)"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: opencameratab1 }"
>
  <!-- <div class="modal-dialog" role="document"> -->
  <!-- <div class="modal-content"> -->
  <!-- <div class="modal-content"> -->
  <!-- <div class="modal-body text-center"> -->
  <!--  -->
  <!-- <img [src]="previewImageUrl" class="img-fluid rounded" alt="Preview" /> -->
  <!-- </div> -->
  <!-- <div class="modal-footer d-flex justify-content-center"> -->
  <!-- <button class="btn btn-primary" (click)="closeImagePreview()">Close</button> -->
  <!-- </div> -->
  <!-- </div> -->
  <!--  -->
  <!-- </div> -->
  <!-- </div> -->

  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content file-preview-modal">
      <!-- Header -->
      <div class="modal-header border-0 d-flex align-items-center">
        <div class="d-flex align-items-center gap-3">
         <div class="user-avatar ">
  <!-- If image exists -->
  <ng-container *ngIf="selectedUser?.image; else initialsAvatar">
    <img
      [src]="drImageBaseUrl + selectedUser.image"
      class="user-avatar-img"
      [alt]="selectedUser?.full_name"
      (error)="onImageError(selectedUser)"
    />
  </ng-container>

  <!-- Otherwise show initials -->
  <ng-template #initialsAvatar>
    <div class="avatar-fallback">
      {{ getInitials(selectedUser?.full_name) }}
    </div>
  </ng-template>
</div>
          <div>
            <h6 class="mb-0">{{ selectedUser?.full_name || "User" }}</h6>
            <small class="text-muted">{{
              getMessageDate(selectedFileMsg) | date : "d MMM, h:mm a"
            }}</small>
          </div>
        </div>
    <div style="display: flex;justify-content: flex-end;gap: 20px;align-items: center;margin-left: auto;margin-right: 0;">
  <!-- Download Button -->
<!-- Download Button -->
<button (click)="shareContent()" class="download-btn" title="Share" style="background: none; border: none; cursor: pointer;">
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
    <path d="M20.4822 4.69725C20.4822 6.49055 19.0284 7.94431 17.2351 7.94431C15.4417 7.94431 13.988 6.49055 13.988 4.69725C13.988 2.90396 15.4417 1.4502 17.2351 1.4502C19.0284 1.4502 20.4822 2.90396 20.4822 4.69725Z" stroke="#092C44" stroke-width="1.725"/>
    <path d="M7.49412 10.6504C7.49412 12.4437 6.04036 13.8974 4.24706 13.8974C2.45376 13.8974 1 12.4437 1 10.6504C1 8.85703 2.45376 7.40332 4.24706 7.40332C6.04036 7.40332 7.49412 8.85703 7.49412 10.6504Z" stroke="#092C44" stroke-width="1.725"/>
    <path d="M20.4822 16.603C20.4822 18.3964 19.0284 19.8501 17.2351 19.8501C15.4417 19.8501 13.988 18.3964 13.988 16.603C13.988 14.8097 15.4417 13.356 17.2351 13.356C19.0284 13.356 20.4822 14.8097 20.4822 16.603Z" stroke="#092C44" stroke-width="1.725"/>
    <path d="M7.20044 9.29681L14.2357 6.05029M7.20044 12.0032L14.2357 15.2498" stroke="#092C44" stroke-width="1.725"/>
  </svg>
</button>

<!-- Share Button -->
<button (click)="copyText()" title="Copy" class="download-btn"  style="background: none; border: none; cursor: pointer;">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
    <path d="M9.47559 14.375C9.47559 11.6645 9.47559 10.3092 10.3177 9.46707C11.1598 8.625 12.515 8.625 15.2256 8.625H16.1839C18.8945 8.625 20.2497 8.625 21.0918 9.46707C21.9339 10.3092 21.9339 11.6645 21.9339 14.375V15.3333C21.9339 18.0439 21.9339 19.3992 21.0918 20.2412C20.2497 21.0833 18.8945 21.0833 16.1839 21.0833H15.2256C12.515 21.0833 11.1598 21.0833 10.3177 20.2412C9.47559 19.3992 9.47559 18.0439 9.47559 15.3333V14.375Z" stroke="#092C44" stroke-width="1.725" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.1425 8.62484C17.1402 5.79096 17.0973 4.32308 16.2724 3.318C16.1131 3.1239 15.9352 2.94593 15.7411 2.78663C14.6808 1.9165 13.1056 1.9165 9.95508 1.9165C6.80458 1.9165 5.22933 1.9165 4.16907 2.78663C3.97497 2.94592 3.797 3.1239 3.63771 3.318C2.76758 4.37825 2.76758 5.9535 2.76758 9.104C2.76758 12.2545 2.76758 13.8297 3.63771 14.89C3.79699 15.0841 3.97497 15.2621 4.16907 15.4213C5.17415 16.2463 6.64203 16.2891 9.47591 16.2914" stroke="#092C44" stroke-width="1.725" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</button>

<!-- Copy Button -->
<button (click)="downloadFile()" title="Download" class="download-btn"  style="background: none; border: none; cursor: pointer;">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
    <path d="M11.65 21.0832C16.9427 21.0832 21.2333 16.7926 21.2333 11.4998C21.2333 6.20711 16.9427 1.9165 11.65 1.9165C6.35725 1.9165 2.06665 6.20711 2.06665 11.4998C2.06665 16.7926 6.35725 21.0832 11.65 21.0832Z" stroke="#092C44" stroke-width="1.725"/>
    <path d="M11.65 15.3332V7.6665M11.65 15.3332C10.979 15.3332 9.7252 13.422 9.25415 12.9373M11.65 15.3332C12.321 15.3332 13.5748 13.422 14.0458 12.9373" stroke="#092C44" stroke-width="1.725" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</button>

</div>

        <button
          type="button"
          class="btn-close"
          (click)="closeImagePreview()"
        ></button>
      </div>

      <!-- Body -->
      <div class="modal-body text-center p-0" style="padding: 1px 10px 30px 10px !important;">
        <img
          [src]="previewImageUrl"
          class="img-fluid rounded preview-img"
          alt="Preview"
          style="border-radius: 31.256px 28.26px 31.256px 31.256px !important;
"
        />
        <!-- Image Preview -->
        <!-- <img -->
        <!-- *ngIf="isImageFile(previewFileUrl)" -->
        <!-- [src]="previewFileUrl" -->
        <!-- class="img-fluid rounded preview-img" -->
        <!-- alt="Preview" -->
        <!-- /> -->

        <!-- Video Preview -->
      </div>
    </div>
  </div>
</div>

<!-- Camera Modal -->
<!-- Camera Modal -->

<div
  class="modal"
  id="cameraModal"
  style="background: #00000087"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: opencameratab }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-content">
        <div class="modal-body text-center">
          <div
            style="
              margin-left: auto;
              cursor: pointer;
              position: absolute;
              right: 0;
              top: -9px;
            "
            (click)="hideCameraModal()"
          >
            <span style="font-size: x-large" aria-hidden="true">&times;</span>
          </div>
          <video
            #video
            autoplay
            playsinline
            style="width: 100%; border-radius: 8px"
          ></video>
          <canvas #canvas style="display: none"></canvas>
        </div>
        <div class="modal-footer d-flex justify-content-center">
          <button class="btn btn-primary" (click)="capturePhoto()">
            📸 Capture
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
